import React, { useEffect, useState } from "react";
import Drawer from "@mui/material/Drawer";
import CloseIcon from "@mui/icons-material/Close";
import { Box, Typography, MenuItem } from "@mui/material";
import Btn from "../../common/Button/Button";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import Fi from "../Field/Fi";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import CheckIcon from "@mui/icons-material/Check";
import BottomMakeFilterModal from "./BottomMakeFilterModal";

const years = [2000, 2001, 2002, 2003, 2004, 2005, 2006, 2007];
const price = ["100", "200", "300", "400"];
const capacity = ["100", "200", "300", "400"];
const height = ["100", "200", "300", "400"];
const weight = ["100", "200", "300", "400"];

export default function BottomModal({ open, toggleDrawer }) {
  const [bottomMakeModal, setBottomMakeModal] = React.useState(false);
  const toggleDrawerMake = (open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setBottomMakeModal(open);
  };
  const [selectedMake, setSelectedMake] = React.useState([]);
  const [axles, setAxles] = React.useState({
    "Rear Axles": false,
    "Front Axles": false,
    "Stub Axle": false,
    "Semi-Floating Axle": false,
  });
  const [fromYear, setFromYear] = React.useState("");
  const [toYear, setToYear] = React.useState("");
  const [keyword, setKeyword] = React.useState("");
  const [keywords, setKeywords] = React.useState([]);
  const [minPrice, setMinPrice] = React.useState("");
  const [maxPrice, setMaxPrice] = React.useState("");
  const [minCapacity, setMinCapacity] = React.useState("");
  const [maxCapacity, setMaxCapacity] = React.useState("");
  const [minWeight, setMinWeight] = React.useState("");
  const [maxWeight, setMaxWeight] = React.useState("");
  const [minHeight, setMinHeight] = React.useState("");
  const [maxHeight, setMaxHeight] = React.useState("");
  const [tabValue, setTabValue] = React.useState(0);
  const clearAll = () => {
    setToYear("");
    setFromYear("");
    setMinPrice("");
    setMaxPrice("");
    setMinCapacity("");
    setMaxCapacity("");
    setMinWeight("");
    setMinHeight("");
    setMaxHeight("");
    const newAxle = { ...axles };
    Object.keys(axles).forEach((key) => (newAxle[key] = false));
    setAxles(newAxle);
    setTabValue(0);
    setSelectedMake([]);
  };
  const handleChange = (_, newValue) => {
    setTabValue(newValue);
  };
  const handleKeyWordChange = (e) => {
    if (e.key === "Enter") {
      setKeywords([...keywords, keyword]);
      setKeyword("");
    }
  };

  const handleKeywordDelete = (kw) => {
    setKeywords(keywords.filter((k) => k != kw));
  };

  const prevScrollY = React.useRef(0);
  const [y, setY] = React.useState(0);
  const [goingUp, setGoingUp] = useState(false);

  const onScroll = (e) => {
    const currentScrollY = e.target.scrollTop;
    if (prevScrollY.current < currentScrollY && goingUp) {
      setGoingUp(false);
    }
    if (prevScrollY.current > currentScrollY && !goingUp) {
      setGoingUp(true);
    }
    prevScrollY.current = currentScrollY;
    setY(currentScrollY);
  };

  const upward = () => {
    return goingUp && y !== 0;
  };

  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={toggleDrawer(false)}
      PaperProps={{
        sx: {
          height: "100%",
          boxShadow:
            "0px -8px 10px rgba(0, 0, 0, 0.14), 0px -3px 14px rgba(0, 0, 0, 0.12), 0px -5px 5px rgba(0, 0, 0, 0.2)",
        },
      }}
    >
      <div style={{ overflowY: "scroll" }} onScroll={onScroll}>
        <Box
          sx={{
            paddingTop: "28px",
            marginBottom: "24px",
            paddingX: "16px",
            display: "flex",
            flexDirection: "column",
            paddingBottom: upward() ? "24px" : "0",
            position: upward() ? "fixed" : "static",
            width: "100%",
            backgroundColor: "white",
            boxShadow: upward()
              ? "0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)"
              : "",
            zIndex: "10",
          }}
        >
          <Box
            sx={{
              marginBottom: "16px",
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
            }}
          >
            <CloseIcon
              onClick={toggleDrawer(false)}
              sx={{
                marginLeft: "2px",
                "&:hover": {
                  cursor: "pointer",
                },
              }}
            />
            <Typography
              fontWeight="600"
              fontSize="16px"
              lineHeight="24px"
              color="text.primary"
              sx={{ textDecoration: "underline" }}
              onClick={clearAll}
            >
              Clear All
            </Typography>
          </Box>
          <Typography
            variant="h3"
            fontWeight="600"
            fontSize="22px"
            lineHeight="26px"
            color="text.primary"
          >
            Filters
          </Typography>
        </Box>
        <Box sx={{ paddingX: "16px" }}>
          <Heading text="Type" />
          <Box sx={{ display: "flex", columnGap: "8px" }}>
            <Btn
              variant="outlined"
              onClick={(e) => handleChange(e, 0)}
              bgColor={tabValue === 0 ? "#255CCE1A" : "#F5F5F5"}
              outColor={tabValue === 0 ? "#255CCE" : "#FFF"}
              sx={{
                maxWidth: "58px",
                minWidth: "58px",
                height: "36px",
                padding: "6px 16px",
              }}
              size="lg"
              txColor="text.primary"
              typoVariant="body1"
              fontWeight="400"
            >
              Pro
            </Btn>
            <Btn
              variant="outlined"
              onClick={(e) => handleChange(e, 1)}
              bgColor={tabValue === 1 ? "#255CCE1A" : "#F5F5F5"}
              outColor={tabValue === 1 ? "#255CCE" : "#FFF"}
              sx={{
                maxWidth: "61px",
                minWidth: "61px",
                height: "36px",
                padding: "6px 16px",
              }}
              size="lg"
              txColor="text.primary"
              typoVariant="body1"
              fontWeight="400"
            >
              Buy
            </Btn>
            <Btn
              variant="outlined"
              onClick={(e) => handleChange(e, 2)}
              bgColor={tabValue === 2 ? "#255CCE1A" : "#F5F5F5"}
              outColor={tabValue === 2 ? "#255CCE" : "#FFF"}
              sx={{
                maxWidth: "90px",
                minWidth: "90px",
                height: "36px",
                padding: "6px 16px",
              }}
              size="lg"
              txColor="text.primary"
              typoVariant="body1"
              fontWeight="400"
            >
              Auction
            </Btn>
          </Box>
          <Line />
          <CloseBy
            head="Make and Model"
            label="You can add multiple make or model"
            selected={selectedMake}
            onClick={toggleDrawerMake(true)}
          />
          <Line />
          <Heading text="Year" />
          <Years
            toYear={toYear}
            fromYear={fromYear}
            setToYear={setToYear}
            setFromYear={setFromYear}
          />
          <Line />
          <Heading text="Price (AED)" />
          <Price
            minPrice={minPrice}
            maxPrice={maxPrice}
            setMinPrice={setMinPrice}
            setMaxPrice={setMaxPrice}
          />
          <Line />
          <CloseBy
            head="Country"
            label="You can add multiple countries to filter"
          />
          <Line />
          <Heading text="Capacity" />
          <Capacity
            maxCapacity={maxCapacity}
            minCapacity={minCapacity}
            setMaxCapacity={setMaxCapacity}
            setMinCapacity={setMinCapacity}
          />
          <Line />
          <Heading text="Axle configration" />
          <Box
            sx={{
              whiteSpace: "nowrap",
              overflow: "auto",
              "&::-webkit-scrollbar": {
                display: "none",
              },
            }}
          >
            {Object.keys(axles).map((a) => (
              <AxleBtn
                text={a}
                checked={axles[a]}
                onClick={() => setAxles({ ...axles, [a]: !axles[a] })}
              />
            ))}
          </Box>
          <Box
            sx={{
              display: "flex",
              columnGap: "8px",
              width: "100%",
            }}
          ></Box>
          <Line />
          <Heading text="Lifting Weight (KG)" />
          <Lift
            label="Weight"
            minVal={minWeight}
            maxVal={maxWeight}
            handleMinChange={(e) => setMinWeight(e.target.value)}
            handleMaxChange={(e) => setMaxWeight(e.target.value)}
            values={weight}
          />{" "}
          <Line /> <Heading text="Lifting Height (Meter)" />
          <Lift
            label="Height"
            minVal={minHeight}
            maxVal={maxHeight}
            handleMinChange={(e) => setMinHeight(e.target.value)}
            handleMaxChange={(e) => setMaxHeight(e.target.value)}
            values={height}
          />{" "}
          <Line />
          <Heading text="Add Keywords" margin="4" />
          <Fi
            value={keyword}
            handleKeyChange={handleKeyWordChange}
            handleChange={(e) => setKeyword(e.target.value)}
            label="Add keyword"
            height="46.29px"
            sx={{ width: "100%", marginBottom: "16px" }}
            filled={false}
          />
          {keywords.length > 0 && (
            <Box
              sx={{
                whiteSpace: "nowrap",
                overflow: "auto",
                "&::-webkit-scrollbar": {
                  display: "none",
                },
              }}
            >
              {keywords.map((kw, i) => (
                <Btn
                  key={i}
                  variant="outlined"
                  sx={{
                    backgroundColor: "#255CCE1A",
                    borderColor: "#255CCE",
                    padding: "8px",
                    height: "36px",
                    marginRight: "8px",
                  }}
                  size="lg"
                  txColor="text.primary"
                  typoVariant="body1"
                  fontWeight="400"
                  endIcon={
                    <CloseIcon
                      onClick={() => handleKeywordDelete(kw)}
                      sx={{
                        color: "text.primary",
                        width: "16px",
                        height: "16px",
                      }}
                    />
                  }
                >
                  {kw}
                </Btn>
              ))}
            </Box>
          )}
          <Box sx={{ height: "24px" }}></Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            width: "100%",
            justifyContent: "center",
            alignItems: "center",
            boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.8)",
            zIndex: "1000",
            position: goingUp ? "static" : "sticky",
            bottom: "0%",
            backgroundColor: "#fff",
          }}
        >
          <Btn
            variant="contained"
            size="lg"
            txColor="text.primary"
            bgColor="#F9D548"
            sx={{
              margin: "16px",
              height: "48px",
              width: "343px",
              boxShadow: "none",
            }}
            onClick={toggleDrawer(false)}
            hoverBg="#F3C04F"
          >
            Search 150 machinery
          </Btn>
        </Box>
      </div>
      <BottomMakeFilterModal
        open={bottomMakeModal}
        toggleDrawer={toggleDrawerMake}
        selectedMake={selectedMake}
        setSelectedMake={setSelectedMake}
      />
    </Drawer>
  );
}

function AxleBtn({ text, checked, onClick }) {
  return (
    <Btn
      onClick={onClick}
      variant="outlined"
      bgColor={checked ? "#255CCE1A" : "#F5F5F5"}
      outColor={checked ? "#255CCE" : "#FFF"}
      sx={{
        height: "36px",
        padding: "6px 16px",
        marginRight: "8px",
      }}
      size="lg"
      txColor="text.primary"
      typoVariant="body1"
      fontWeight="400"
      startIcon={checked && <CheckIcon sx={{ color: "text.primary" }} />}
    >
      {text}
    </Btn>
  );
}

function Lift({
  minVal,
  maxVal,
  label,
  handleMinChange,
  handleMaxChange,
  values,
}) {
  return (
    <Box
      sx={{
        display: "flex",
        columnGap: "9px",
        marginTop: "24px",
        alignItems: "center",
      }}
    >
      <Fi
        value={minVal}
        handleChange={handleMinChange}
        label={`Min. ${label}`}
        height="46.29px"
        select={true}
        sx={{ width: "50%" }}
      >
        {values.map((v) => (
          <MenuItem key={v} value={v}>
            {v}
          </MenuItem>
        ))}
      </Fi>

      <Fi
        value={maxVal}
        handleChange={handleMaxChange}
        label={`Max. ${label}`}
        height="46.29px"
        select={true}
        sx={{ width: "50%" }}
      >
        {values
          .filter((v) => v > minVal)
          .map((v) => (
            <MenuItem key={v} value={v}>
              {v}
            </MenuItem>
          ))}
      </Fi>
    </Box>
  );
}

function Capacity({
  maxCapacity,
  minCapacity,
  setMaxCapacity,
  setMinCapacity,
}) {
  return (
    <Box sx={{ display: "flex", columnGap: "10px" }}>
      <Fi
        value={minCapacity}
        handleChange={(e) => setMinCapacity(e.target.value)}
        label="Min"
        height="46.29px"
        sx={{ width: "50%" }}
        select={true}
      >
        {capacity.map((c) => (
          <MenuItem key={c} value={c}>
            {c}
          </MenuItem>
        ))}
      </Fi>
      <Fi
        value={maxCapacity}
        handleChange={(e) => setMaxCapacity(e.target.value)}
        label="Max."
        height="46.29px"
        select={true}
        sx={{ width: "50%" }}
      >
        {capacity
          .filter((c) => c > minCapacity)
          .map((c) => (
            <MenuItem key={c} value={c}>
              {c}
            </MenuItem>
          ))}
      </Fi>
    </Box>
  );
}

function CloseBy({ head, label, onClick, selected }) {
  return (
    <Box
      onClick={onClick}
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Box>
        <Typography
          variant="subtitle1"
          fontWeight="600"
          fontSize="16px"
          lineHeight="24px"
          color="text.primary"
          sx={{ marginBottom: "4px" }}
        >
          {head}
        </Typography>
        <Typography
          variant="body1"
          fontFamily="Inter"
          fontSize="16px"
          fontWeight="400"
          lineHeight="24px"
          color={selected && selected.length > 0 ? "primary.main" : "#616161"}
        >
          {selected && selected.length > 0
            ? `${selected.slice(0, 3).join(", ")}${
                selected.length - 3 > 0
                  ? ` and ${selected.length - 3} more`
                  : ""
              }`
            : label}
        </Typography>
      </Box>
      <ChevronRightIcon sx={{ color: "#616161" }} />
    </Box>
  );
}

function Price({ minPrice, maxPrice, setMinPrice, setMaxPrice }) {
  return (
    <Box sx={{ display: "flex", columnGap: "10px" }}>
      <Fi
        value={minPrice}
        handleChange={(e) => setMinPrice(e.target.value)}
        label="Min."
        height="46.29px"
        sx={{ width: "50%" }}
        select={true}
      >
        {price.map((p) => (
          <MenuItem key={p} value={p}>
            {p}
          </MenuItem>
        ))}
      </Fi>
      <Fi
        value={maxPrice}
        handleChange={(e) => setMaxPrice(e.target.value)}
        label="Max."
        height="46.29px"
        sx={{ width: "50%" }}
        select={true}
      >
        {price
          .filter((p) => p > minPrice)
          .map((p) => (
            <MenuItem key={p} value={p}>
              {p}
            </MenuItem>
          ))}
      </Fi>
    </Box>
  );
}

function Years({ fromYear, toYear, setFromYear, setToYear }) {
  return (
    <Box sx={{ display: "flex", columnGap: "10px" }}>
      <Fi
        value={fromYear}
        handleChange={(e) => setFromYear(e.target.value)}
        label="From"
        height="46.29px"
        sx={{ width: "50%" }}
        select={true}
      >
        {years.map((p) => (
          <MenuItem key={p} value={p}>
            {p}
          </MenuItem>
        ))}
      </Fi>
      <Fi
        value={toYear}
        handleChange={(e) => setToYear(e.target.value)}
        label="To"
        height="46.29px"
        sx={{ width: "50%" }}
        select={true}
      >
        {years.map((p) => (
          <MenuItem key={p} value={p}>
            {p}
          </MenuItem>
        ))}
      </Fi>
    </Box>
  );
}

function Heading({ text, margin = "8" }) {
  return (
    <Typography
      variant="subtitle1"
      fontWeight="600"
      fontSize="16px"
      lineHeight="24px"
      color="text.primary"
      sx={{ marginBottom: `${margin}px` }}
    >
      {text}
    </Typography>
  );
}

function Line() {
  return (
    <Box
      sx={{
        marginY: "24px",
        width: "100%",
        height: "1px",
        backgroundColor: "#D6D6D6",
      }}
    ></Box>
  );
}
